export class ServiceAlreadyExistsError extends Error {
  constructor(serviceIdentifier: string, isShared: boolean) {
    super(`${isShared ? '' : 'Non'}Shared service: "${serviceIdentifier}" already exists.`);
  }
}
